// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ei-3";
export var flatBottomCorners = "_ei-5";
export var productImage = "_ei-0";
export var quantityContainer = "_ei-2";
export var quantityHeader = "_ei-6";
export var tooltip = "_ei-1";
export var wrapAndEllipsesOverflow = "_ei-4";